export enum CommentType {
  User = 'User',
  AssigneeUpdate = 'AssigneeUpdate',
  StatusUpdate = 'StatusUpdate',
}
